import { PdfFieldEditor } from "../components/PdfFieldEditor";

export function CfrTemplateCreatePage() {
  return <PdfFieldEditor />;
}

